import Helper from '@ember/component/helper';
import { inject as service } from '@ember/service';
import AccountService from 'cio/services/account';
import { DataCenter } from 'cio/models/account';
import { getApiHost, CioApi } from 'cio/utils/data-centers';

export default class extends Helper {
  @service account!: AccountService;

  compute([api]: [CioApi]) {
    return getApiHost(api, this.account.current?.dataCenter ?? DataCenter.US);
  }
}
